import { Injectable } from '@angular/core';
import { CommonService } from './common.service';
import { appConfig , baseUrl,localUrl,intUrl} from '../app.config';
import { Observable } from 'rxjs';
import { emailAddresses,emailAddressesArray,personAddresses,personAddressesArray,personRoles,personRolesArray,PersonRoleTypes,personRoleTypesArray,persons,personsArray,siteRoles,siteRolesArray,supplierCompanyRoles,supplierCompanyRolesArray,supplierGroupRoles,supplierGroupRolesArray,telephoneAddresses,telephoneAddressesArray,users, usersArray } from './models/contactModel';

@Injectable({
  providedIn: 'root'
})
export class ContactsService {
  config:any;
  apiUrl: string='';
  constructor(private apiService: CommonService) {
    // this.config=appConfig
    this.apiUrl=appConfig.contactServiceUrl;
    console.info("api",this.apiUrl)
   }
   // old site-roles -->supplierSiteRoles
    getSiteRoles(url: string):Observable<siteRolesArray> {
       let data = this.apiService.getServiceCall(`${this.apiUrl}/get-site-roles`, url) as Observable<siteRolesArray>;
       return this.apiService.response(data,siteRolesArray,'supplierSiteRoles') as Observable<siteRolesArray>;
      }
    getSiteRolesbyId(url: string):Observable<siteRoles> {
       let data = this.apiService.getServiceCall(`${this.apiUrl}/get-site-roles`, url) as Observable<siteRoles>;
       return this.apiService.response(data,siteRoles,'supplierSiteRoles') as Observable<siteRoles>;
    }
    createSiteRoles(url,data):Observable<siteRoles> {
        return this.apiService.postServiceCall(`${this.apiUrl}/create-site-roles`, url,data) as Observable<siteRoles>;
      }
     updateSiteRoles(url: string,data):Observable<siteRoles> {
      return this.apiService.UpdateServiceCall(`${this.apiUrl}/update-site-roles`, url,data) as Observable<siteRoles>;
     }
      deleteSiteRoles(url):Observable<any> {
         return this.apiService.deleteServiceCall(`${this.apiUrl}/delete-site-roles`, url) as Observable<any>;
       }
       // old telephone-addresses  --> telephoneAddresses
   getTelephoneAddresses(url: string):Observable<telephoneAddressesArray> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-telephone-addresses`, url) as Observable<telephoneAddressesArray>;
    return this.apiService.response(data,telephoneAddressesArray,'telephoneAddresses') as Observable<telephoneAddressesArray>;
   }
   getTelephoneAddressesById(url: string):Observable<telephoneAddresses> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-telephone-addresses`, url) as Observable<telephoneAddresses>;
    return this.apiService.response(data,telephoneAddresses,'telephoneAddresses') as Observable<telephoneAddresses>;
 }
 createTelephoneAddress(url: string,data):Observable<telephoneAddresses> {
   return this.apiService.postServiceCall(`${this.apiUrl}/create-telephone-addresses`, url,data) as Observable<telephoneAddresses>;
  }
  updateTelephoneAddresses(url: string,data):Observable<telephoneAddresses> {
   return this.apiService.UpdateServiceCall(`${this.apiUrl}/update-telephone-addresses`, url,data) as Observable<telephoneAddresses>;
  }
  deleteTelephoneAddresses(url):Observable<any> {
      return this.apiService.deleteServiceCall(`${this.apiUrl}/delete-telephone-addresses`, url) as Observable<any>;
  }

 // old users --> users
  getUsers(url: string):Observable<usersArray> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-users`, url) as Observable<usersArray>;
    return this.apiService.response(data,usersArray,'users') as Observable<usersArray>;
   }
   getUsersbyId(url: string):Observable<users> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-users`, url) as Observable<users>;
    return this.apiService.response(data,users,'users') as Observable<users>;
 }
 createUsers(url: string,data):Observable<users> {
   return this.apiService.postServiceCall(`${this.apiUrl}/create-users`, url,data) as Observable<users>;
  }
  updateUsers(url: string,data):Observable<users> {
   return this.apiService.UpdateServiceCall(`${this.apiUrl}/update-users`, url,data) as Observable<users>;
  }
  deleteusers(url):Observable<any> {
      return this.apiService.deleteServiceCall(`${this.apiUrl}/delete-users`, url) as Observable<any>;
  }
    // old  supplier-company-roles   --> supplierCompanyRoles
  getSupplierCompanyRoles(url: string):Observable<supplierCompanyRolesArray> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-supplier-company-roles`, url) as Observable<supplierCompanyRolesArray>;
    return this.apiService.response(data,supplierCompanyRolesArray,'supplierCompanyRoles') as Observable<supplierCompanyRolesArray>
   }
   getSupplierCompanyRolesbyId(url: string):Observable<supplierCompanyRoles> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-supplier-company-roles`, url) as Observable<supplierCompanyRoles>;
    return this.apiService.response(data,supplierCompanyRoles,'supplierCompanyRoles') as Observable<supplierCompanyRoles>;
 }
 createSupplierCompanyRoles(url: string,data):Observable<supplierCompanyRoles> {
   return this.apiService.postServiceCall(`${this.apiUrl}/create-supplier-company-roles`, url,data) as Observable<supplierCompanyRoles>;
  }
  updateSupplierCompanyRoles(url: string,data):Observable<supplierCompanyRoles> {
   return this.apiService.UpdateServiceCall(`${this.apiUrl}/update-supplier-company-roles`, url,data) as Observable<supplierCompanyRoles>;
  }
   deleteSupplierCompanyRoles(url):Observable<any> {
      return this.apiService.deleteServiceCall(`${this.apiUrl}/delete-supplier-company-roles`, url) as Observable<any>;
  }

    // old supplier-group-roles   --> supplierGroupRoles
  getSuppliergroupRoles(url: string):Observable<supplierGroupRolesArray> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-supplier-group-roles`, url) as Observable<supplierGroupRolesArray>;
    return this.apiService.response(data,supplierGroupRolesArray,'supplierGroupRoles') as Observable<supplierGroupRolesArray>;
   }
   getSuppliergroupRolesbyId(url: string):Observable<supplierGroupRoles> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-supplier-group-roles`, url) as Observable<supplierGroupRoles>;
    return this.apiService.response(data,supplierGroupRoles,'supplierGroupRoles') as Observable<supplierGroupRoles>;
 }
 createSuppliergroupRoles(url: string,data):Observable<supplierGroupRoles> {
   return this.apiService.postServiceCall(`${this.apiUrl}/create-supplier-group-roles`, url,data) as Observable<supplierGroupRoles>;
  }
  updateSuppliergroupRoles(url: string,da):Observable<supplierGroupRoles> {
   return this.apiService.UpdateServiceCall(`${this.apiUrl}/update-supplier-group-roles`, url,da) as Observable<supplierGroupRoles>;
  }
  deletesupplierGroupRoles(url):Observable<any> {
    return this.apiService.deleteServiceCall(`${this.apiUrl}/delete-supplier-group-roles`, url) as Observable<any>;
  }
    // old persons ---> persons
  getPersons(url: string):Observable<personsArray> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-persons`, url) as Observable<personsArray>;
    return this.apiService.response(data,personsArray,'persons') as Observable<personsArray>;
   }
   getPersonsbyId(url: string):Observable<persons> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-persons`, url) as Observable<persons>;
    return this.apiService.response(data,persons,'persons') as Observable<persons>;
 }
 createPersons(url: string,data):Observable<persons> {
   return this.apiService.postServiceCall(`${this.apiUrl}/create-persons`, url,data) as Observable<persons>;
  }
  updatePersons(url: string,data):Observable<persons> {
   return this.apiService.UpdateServiceCall(`${this.apiUrl}/update-persons`, url,data) as Observable<persons>;
  }
  deletePersons(url):Observable<any> {
    return this.apiService.deleteServiceCall(`${this.apiUrl}/delete-persons`, url) as Observable<any>;
  }
  // old email-addresses --> emailAddresses
  getEmailAddresss(url: string):Observable<emailAddressesArray> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-email-addresses`, url) as Observable<emailAddressesArray>;
    return this.apiService.response(data,emailAddressesArray,'emailAddresses') as Observable<emailAddressesArray>;
   }
   getEmailAddresssbyId(url: string):Observable<emailAddresses> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-email-addresses`, url) as Observable<emailAddresses>;
    return this.apiService.response(data,emailAddresses,'emailAddresses') as Observable<emailAddresses>;
 }
 createEmailAddress(url: string,data):Observable<emailAddresses> {
   return this.apiService.postServiceCall(`${this.apiUrl}/create-email-addresses`, url,data) as Observable<emailAddresses>;
  }
  updateEmailAddresses(url: string,data):Observable<emailAddresses> {
   return this.apiService.UpdateServiceCall(`${this.apiUrl}/update-email-addresses`, url,data) as Observable<emailAddresses>;
  }
   deleteEmailAddresses(url):Observable<any> {
      return this.apiService.deleteServiceCall(`${this.apiUrl}/delete-email-addresses`, url) as Observable<any>;
    }

  //  old person-roles     -->personRoles
  getPersonRoles(url: string):Observable<personRolesArray> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-person-roles`, url) as Observable<personRolesArray>;
    return this.apiService.response(data,personRolesArray,'personRoles') as Observable<personRolesArray>;
   }
   getPersonRolesbyId(url: string):Observable<personRoles> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-person-roles`, url) as Observable<personRoles>;
    return this.apiService.response(data,personRoles,'personRoles') as Observable<personRoles>;
 }
 createPersonRoles(url: string,data):Observable<personRoles> {
   return this.apiService.postServiceCall(`${this.apiUrl}/create-person-roles`, url,data) as Observable<personRoles>;
  }
  updatePersonRoles(url: string,data):Observable<personRoles> {
   return this.apiService.UpdateServiceCall(`${this.apiUrl}/update-person-roles`, url,data) as Observable<personRoles>;
  }
  deletePersonRoles(url):Observable<any> {
    return this.apiService.deleteServiceCall(`${this.apiUrl}/delete-person-roles`, url) as Observable<any>;
  }
    //old person-addresses  -->personAddresses
  getPersonAddresses(url: string):Observable<personAddressesArray> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-person-addresses`, url) as Observable<personAddressesArray>;
    return this.apiService.response(data,personAddressesArray,'personAddresses') as Observable<personAddressesArray>;
   }
   getPersonAddressesbyId(url: string):Observable<personAddresses> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-person-addresses`, url) as Observable<personAddresses>;
    return this.apiService.response(data,personAddresses,'personAddresses') as Observable<personAddresses>;
 }
 createPersonAddresses(url: string,data):Observable<personAddresses> {
   return this.apiService.postServiceCall(`${this.apiUrl}/create-person-addresses`, url,data) as Observable<personAddresses>;
  }
  updatePersonAddresses(url: string,data):Observable<personAddresses> {
   return this.apiService.UpdateServiceCall(`${this.apiUrl}/update-person-addresses`, url,data) as Observable<personAddresses>;
  }
  deletePersonAddresses(url):Observable<any> {
      return this.apiService.deleteServiceCall(`${this.apiUrl}/delete-person-addresses`, url) as Observable<any>;
  }
    //old person-role-types  --->personRoleTypes
  getPersonRoleTypes(url: string):Observable<personRoleTypesArray> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-person-role-types`, url)
    return this.apiService.response(data,personRoleTypesArray,'personRoleTypes') as Observable<personRoleTypesArray>;
  }
   getPersonRoleTypesbyId(url: string):Observable<PersonRoleTypes> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-person-role-types`, url) as Observable<PersonRoleTypes>;
    return this.apiService.response(data,PersonRoleTypes,'personRoleTypes') as Observable<PersonRoleTypes>;
 }
 createPersonRoleTypes(url: string,data):Observable<PersonRoleTypes> {
   return this.apiService.postServiceCall(`${this.apiUrl}/create-person-role-types`, url,data) as Observable<PersonRoleTypes>;
  }
  updatePersonRoleTypes(url: string,data):Observable<PersonRoleTypes> {
   return this.apiService.UpdateServiceCall(`${this.apiUrl}/update-person-role-types`, url,data) as Observable<PersonRoleTypes>;
  }
  deletePersonRoleTypes(url):Observable<any> {
      return this.apiService.deleteServiceCall(`${this.apiUrl}/delete-person-role-types`, url) as Observable<any>;
  }
}